import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class CashierBiLoggerService {
  getDefaultParams() {
    return {};
  }
  constructor(logger) {
    _defineProperty(this, "logger", void 0);
    _defineProperty(this, "errorMonitor", void 0);
    _defineProperty(this, "onReport", void 0);
    this.logger = logger;
  }
  /* In case you have a type error for params and you pass valid param - make sure it's not sent by default.
   * Check the type of `.getDefaultParams()` in your service. There might be cases when you want to override
   * the default param. In that case add "// @ts-expect-error default field override" before the field.
   * Field itself must be the last in the object with bi params, as ts-expect-error disabled all checks for rest of
   * the fields in the object that are defined after the one you apply this directive to.
   * example (bad):
   * {
   *   param1: 'value1',
   *   // @ts-expect-error default (will be also applied to param3)
   *   param2: 'override the default value',
   *   param3: 'value3',
   * }
   * example (good):
   * {
   *   param1: 'value1',
   *   param3: 'value3',
   *   // @ts-expect-error default
   *   param2: 'override the default value',
   * }
   * */
  report(fn, params) {
    try {
      var _this$onReport;
      const reportParams = fn({
        ...this.getDefaultParams(),
        ...((typeof params === 'function' ? params() : params) ?? {})
      });
      (_this$onReport = this.onReport) == null || _this$onReport.call(this, fn, reportParams);
      return this.logger.report(reportParams);
    } catch (e) {
      var _this$errorMonitor;
      (_this$errorMonitor = this.errorMonitor) == null || _this$errorMonitor.captureException(e);
      if (!this.errorMonitor) {
        throw e;
      }
      return undefined;
    }
  }
}
//# sourceMappingURL=CashierBiLoggerService.js.map